"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _angieslistReactComponents = require("angieslist-react-components");
var _reactTruncate = _interopRequireDefault(require("react-truncate"));
var _angieslistStyles = require("angieslist-styles");
var _truncateWidthsByCardStyle = _interopRequireDefault(require("./utils/truncateWidthsByCardStyle"));
var darkestGray = _angieslistStyles.stylesColors.darkestGray,
  darkGray = _angieslistStyles.stylesColors.darkGray;
var DealCardBody = function DealCardBody(_ref) {
  var spName = _ref.spName,
    grade = _ref.grade,
    reviewCount = _ref.reviewCount,
    cardStyle = _ref.cardStyle;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontSize: '12px',
      color: darkestGray,
      paddingBottom: 1
    }
  }, "OFFERED BY"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontSize: '15px',
      color: darkGray,
      fontWeight: 'bold',
      paddingBottom: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactTruncate["default"], {
    lines: 1,
    width: _truncateWidthsByCardStyle["default"][cardStyle]
  }, spName)), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Grade, {
    value: grade,
    bsStyle: "small"
  }), ' ', /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: darkestGray,
      fontSize: 14
    }
  }, /*#__PURE__*/_react["default"].createElement("b", null, "".concat(reviewCount, " "))), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontSize: 14,
      color: darkGray
    }
  }, "Reviews")));
};
DealCardBody.propTypes = {
  spName: _propTypes["default"].string.isRequired,
  grade: _propTypes["default"].string.isRequired,
  reviewCount: _propTypes["default"].number.isRequired,
  cardStyle: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = DealCardBody;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/offers/dealCardbody.js
// module id = 6274
// module chunks = 25